'use client';
import { round } from '@s7/utils';
import { getCssDimensions } from '../utils/getCssDimensions.js';
import { unwrapElement } from '../utils/unwrapElement.js';
import { createCoords } from '../../utils/base.js';
import { isHTMLElement } from '../../utils/dom.js';

function getScale(element) {
    var domElement = unwrapElement(element);
    if (!isHTMLElement(domElement)) {
        return createCoords(1);
    }
    var rect = domElement.getBoundingClientRect();
    var _getCssDimensions = getCssDimensions(domElement), width = _getCssDimensions.width, height = _getCssDimensions.height, $ = _getCssDimensions.$;
    var x = ($ ? round(rect.width) : rect.width) / width;
    var y = ($ ? round(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) {
        x = 1;
    }
    if (!y || !Number.isFinite(y)) {
        y = 1;
    }
    return {
        x: x,
        y: y
    };
}

export { getScale };
